(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lazy-video"] && !Shopify.designMode) return;
  try {
    (function() {
    var $url = document.querySelector('.as-lazy-video-script')
    if (!window.lazyVideo && $url) {
      window.lazyVideo = $url.value

      var $script = document.createElement('script')
      $script.src = window.lazyVideo
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  } catch(e) { console.error(e); }
})();

})();
